export default [
  {
    path: 'dashboard',
    name: 'dashboard',
    component: () => import('./views/DashboardView.vue'),
    meta: { 
      requiresAuth: true,
      title: 'Dashboard' ,
      menuResource: 'DASHBOARD'
    },
  },
]